export default __webpack_public_path__ + "static/media/peter_blamey.ea958724.jpg";